/** App Store — تطبيق مشهد iOS */
export const APP_STORE_URL =
  'https://apps.apple.com/sa/app/%D9%85%D8%B4%D9%87%D8%AF/id6762574398?l=ar';

export const APP_STORE_ID = '6762574398';

/** localStorage: إخفاء بانر التحميل نهائياً بعد الإغلاق أو الضغط على App Store */
export const APP_DOWNLOAD_BANNER_DISMISSED_KEY = 'mashhad_app_download_banner_dismissed';
